if (!customElements.get('scrolling-banner')) {
  class ScrollingBanner extends HTMLElement {
    constructor() {
      super();

      // Duplicate the content until it fits the container
      this.duplicateUntilFit();

      // Check if there is a countdown timer
      const countdown = this.querySelectorAll('[data-countdown]');
      if (countdown.length > 0) {
        countdown.forEach((elm) => {
          this.triggerCountdown(elm);
        });
      }
    }

    triggerCountdown(elm) {
      let countdownDate = elm.dataset.countdownDate;
      let countdownTime = elm.dataset.countdownTime;
      if (countdownTime === null || countdownTime === undefined || countdownTime === '') {
        countdownTime = '23:59';
      }
      if (countdownDate && countdownTime) {
        this.runCountdown(this, countdownDate, countdownTime);
      }
    }

    duplicateUntilFit() {
      const container = this;
      const content = this.querySelector('[data-content]');

      var containerWidth = container.offsetWidth; // Width of the container
      containerWidth = containerWidth * 2.5; // Width of the container
      let contentWidth = content.offsetWidth; // Width of the content

      var originalContent = content.innerHTML; // Store the original content

      // Keep appending the content until the total width of the content surpasses the container's width
      while (contentWidth < containerWidth) {
        content.innerHTML += originalContent; // Duplicate the content
        contentWidth = content.offsetWidth; // Update the width after duplication
        console.log('contentWidth', contentWidth);
      }
    }

    runCountdown(elm, countdownDate, countdownTime) {
      const dayElms = elm.querySelectorAll('[data-countdown-days');
      const hourElms = elm.querySelectorAll('[data-countdown-hours');
      const minElms = elm.querySelectorAll('[data-countdown-min');
      const secElms = elm.querySelectorAll('[data-countdown-sec');

      // Set the date we're counting down to
      var countDownDate = new Date(countdownDate);
      const hours = parseInt(countdownTime.split(':')[0]);
      const minutes = parseInt(countdownTime.split(':')[1]);
      countDownDate.setHours(hours, minutes, 0, 0);
      countDownDate = countDownDate.getTime();

      // Update the count down every 1 second
      var x = setInterval(function () {
        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Output the result in an element with id="demo"
        dayElms.forEach((dayElm) => {
          dayElm.innerHTML = days;
        });
        hourElms.forEach((hourElm) => {
          hourElm.innerHTML = hours;
        });
        minElms.forEach((minElm) => {
          minElm.innerHTML = minutes;
        });
        secElms.forEach((secElm) => {
          secElm.innerHTML = seconds;
        });

        // If the count down is over, write some text
        if (distance < 0) {
          clearInterval(x);
          elm.querySelectorAll('.countdown__item').forEach((item) => {
            item.classList.add('hidden');
          });
          elm.querySelectorAll('[data-countdown-end-text').forEach((item) => {
            item.classList.remove('hidden');
          });

          //Hide countdown elements if data-hide-on-end is set to true
          const countdowns = elm.querySelectorAll('[data-countdown]');
          if (countdowns.length > 0) {
            countdowns.forEach((countdown) => {
              countdown.dataset.hideOnEnd === 'true' ? countdown.classList.add('hidden') : '';
            });
          }
        }
      }, 1000);
    }
  }
  customElements.define('scrolling-banner', ScrollingBanner);
}
